import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.name.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ContactExtraUserInfo from "./ContactExtraUserInfo";
import ContactCardCompanyInfo from "./ContactCardCompanyInfo";
import classnames from "classnames";
import { formatImageUrl } from "@/common/utils";
import "./ContactCard.scss";
import ContactCardCustomerSvc from "./ContactCardCustomerSvc";
import { ImageSizeTypeEnum } from "@/apis/model/ImageSizeTypeEnum";

var ContactCard =
/** @class */
function (_super) {
  __extends(ContactCard, _super);

  function ContactCard() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      currentTab: "company"
    };
    return _this;
  }

  ContactCard.prototype.render = function () {
    var _this = this;

    var contact = this.props.contact;
    var currentTab = this.state.currentTab;
    var info = contact.getContactInfo();
    var inactiveTabClass = "chat-contact-info__item";
    var activeTabClass = inactiveTabClass + "settings-theme_color_text";
    var avatarUrl = formatImageUrl(info.avatarUrl, ImageSizeTypeEnum.Thumbnail200whFit);
    return _jsxs("div", __assign({
      className: "chat-contact-info"
    }, {
      children: [_jsxs("ul", __assign({
        className: "chat-contact-info__list"
      }, {
        children: [contact.user && contact.user.User.Company && _jsx("li", __assign({
          className: classnames("chat-contact-info__item chat-contact-info__first-item", {
            "chat-contact-info__item--active settings-theme_color_border_color": currentTab === "company"
          }),
          onClick: function onClick(e) {
            return _this.setState({
              currentTab: "company"
            });
          }
        }, {
          children: "\u4F01\u4E1A\u4FE1\u606F"
        }), void 0), contact.user && _jsx("li", __assign({
          className: classnames("chat-contact-info__item", {
            "chat-contact-info__item--active settings-theme_color_border_color": currentTab === "user"
          }),
          onClick: function onClick(e) {
            return _this.setState({
              currentTab: "user"
            });
          }
        }, {
          children: "\u4E2A\u4EBA\u4FE1\u606F"
        }), void 0)]
      }), void 0), this.state.currentTab === "user" && contact.user && contact.user.User && contact.user.User.Company && _jsxs("div", __assign({
        className: "chat-contact-info__personal"
      }, {
        children: [_jsx("a", __assign({
          href: info.linkUrl,
          target: "_blank",
          className: "chat-contact-info__avatar"
        }, {
          children: _jsx("img", {
            src: avatarUrl
          }, void 0)
        }), void 0), _jsx("h4", {
          children: _jsx("a", __assign({
            href: info.linkUrl,
            className: "chat-contact-info__name",
            target: "_blank"
          }, {
            children: info.name
          }), void 0)
        }, void 0), contact.user && _jsx(ContactExtraUserInfo, {
          user: contact.user,
          company: contact.user.User.Company
        }, void 0)]
      }), void 0), this.state.currentTab === "company" && contact.user && contact.user.User && contact.user.User.Company && contact.user.User.Company.CompanyId && _jsx(ContactCardCompanyInfo, {
        companyId: contact.user.User.Company.CompanyId
      }, void 0), this.state.currentTab === "company" && contact.user && contact.user.User && contact.user.User.Company && contact.user.User.Company.CustomerServiceCount > 0 && _jsx(ContactCardCustomerSvc, {
        companyId: contact.user.User.Company.CompanyId
      }, void 0)]
    }), void 0);
  };

  return ContactCard;
}(React.Component);

export default ContactCard;